import {
  BillingUnit,
  convertBillingUnit,
  convertReportType,
  convertTypologyCategory,
  convertTypologyPriceType,
  convertTypologyPropertyType,
  convertTypologyRuleKeyword,
  ReportType,
  TypologyCategory,
  TypologypropertyType,
  TypologyPriceType,
  TypologyRuleKeyword,
} from '../../../../../../api/theHive/typology/enumerations';
import { ALL_SIZES } from './types';

export interface SelectProps {
  value: string;
  label: string;
}

export interface NumericSelectProps {
  value: number;
  label: string;
}

export const selectTypologyPropertyType = (): SelectProps[] => {
  const enumValues = Object.values(TypologypropertyType).filter(
    (v) => typeof v === 'string'
  );

  return enumValues.map((value) => {
    return {
      value,
      label: convertTypologyPropertyType(value),
    };
  });
};

export const selectTypologyRuleKeyword = (): SelectProps[] => {
  const enumValues = Object.values(TypologyRuleKeyword).filter(
    (v) => typeof v === 'string'
  );

  const options: SelectProps[] = enumValues.map((value) => ({
    value,
    label: convertTypologyRuleKeyword(value),
  }));

  // opção de UI que mapeia para over + rule_first_value=1
  options.push({ value: ALL_SIZES, label: 'Todos os tamanhos' });
  return options;
};

export const selectTypologyCategory = (): SelectProps[] =>
  Object.values(TypologyCategory).map((value) => ({
    value,
    label: convertTypologyCategory(value),
  }));

export const selectReportType = (): SelectProps[] =>
  Object.values(ReportType).map((value) => ({
    value,
    label: convertReportType(value),
  }));

export const selectBillingUnit = (): SelectProps[] =>
  Object.values(BillingUnit).map((value) => ({
    value,
    label: convertBillingUnit(value),
  }));

export const selectPriceType = (): SelectProps[] =>
  Object.values(TypologyPriceType).map((value) => ({
    value,
    label: convertTypologyPriceType(value),
  }));

export const selectGrouping = (): NumericSelectProps[] =>
  [1, 2, 3, 4].map((n) => ({ value: n, label: `GRUPO ${n}` }));
